import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsDisplay = ({ metrics }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics?.map((metric, index) => (
        <div 
          key={index}
          className="p-4 rounded-lg bg-card border border-border hover:border-accent/50 transition-all duration-200"
        >
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-lg bg-accent/10 flex items-center justify-center">
              <Icon name={metric?.icon} size={16} color="var(--color-accent)" />
            </div>
            <span className="text-xs text-muted-foreground">{metric?.label}</span>
          </div>
          <div className="flex items-baseline gap-1">
            <span className="text-2xl font-bold text-foreground">{metric?.value}</span>
            {metric?.unit && (
              <span className="text-sm text-muted-foreground">{metric?.unit}</span>
            )}
          </div>
          {metric?.change && (
            <div className={`flex items-center gap-1 mt-1 ${
              metric?.change > 0 ? 'text-success' : 'text-destructive'
            }`}>
              <Icon name={metric?.change > 0 ? 'TrendingUp' : 'TrendingDown'} size={12} />
              <span className="text-xs font-medium">{Math.abs(metric?.change)}%</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MetricsDisplay;